const DEFAULT_SEPARATOR = '-';
const DEFAULT_FALLBACK_PREFIX = 'id';

type GenerateIdOptions = {
  prefix?: string;
  separator?: string;
  length?: number;
  fallbackPrefix?: string;
};

const cryptoAPI: Crypto | undefined =
  typeof globalThis !== 'undefined' && 'crypto' in globalThis ? (globalThis.crypto as Crypto) : undefined;

function createRandomBase(): string {
  if (cryptoAPI && typeof cryptoAPI.randomUUID === 'function') {
    return cryptoAPI.randomUUID().replace(/-/g, '');
  }
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).slice(2, 10);
  return `${timestamp}${random}`;
}

function normalizePrefix(prefix?: string, fallbackPrefix = DEFAULT_FALLBACK_PREFIX): string | undefined {
  const candidate = (prefix ?? '').trim();
  if (candidate) {
    return candidate;
  }
  const fallback = (fallbackPrefix ?? '').trim();
  return fallback || undefined;
}

export function generateId(options: GenerateIdOptions = {}): string {
  const separator = options.separator ?? DEFAULT_SEPARATOR;
  const rawPrefix = normalizePrefix(options.prefix, options.fallbackPrefix);

  let base = createRandomBase();
  if (options.length != null && options.length > 0) {
    const limit = Math.floor(options.length);
    base = base.slice(0, limit);
  }

  if (!rawPrefix) {
    return base;
  }

  const normalizedSeparator = separator != null ? String(separator) : DEFAULT_SEPARATOR;
  return `${rawPrefix}${normalizedSeparator}${base}`;
}

export function generateShortId(prefix?: string): string {
  return generateId({ prefix, length: 12 });
}
